import React from "react"
import { Card, CardModal, CardTitle } from "../../components/Card"
import { HeaderContent } from "../../components/Header"

import { componentType } from "../../components/Chart"
import { Slide } from "react-slideshow-image"
import "react-slideshow-image/dist/styles.css"
import { MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos } from "react-icons/md"
import { BsPinAngleFill } from "react-icons/bs"
import { EmptyScreen } from "../../components/Empty"
import { ListSuggestionsItem } from "../../components/ListSuggestionsItem"

import "./styles.scss"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { Button, ButtonLoader } from "../../components/Button"
// import MultiSelectCheckbox from "../../components/TreeView/index.js"
import { FormRow, Input, Label } from "../../components/Form"
import { LinkOrUpload } from "../../components/LinkOrUpload"
import { isValidURL } from "../../core/utils/validateFields"

const CardComponents = ({ index, component, onChangeFixedComponent }) => {
  return (
    <Card
      className={component?.type === "table" ? "card-diagnosis table" : "card-diagnosis"}
      key={index}>
      {component?.type !== null && (
        <HeaderContent>
          <CardTitle title={`${component?.title}`} className="flex-start" />
          <div
            className="card-diagnosis-link"
            onClick={() => onChangeFixedComponent(component?.type)}>
            Fixar
            <BsPinAngleFill color="#0146ad" style={{ marginLeft: "8px" }} size={20} />
          </div>
        </HeaderContent>
      )}

      {componentType(component.type, {
        data: component,
        backgroundColor: index % 2 === 0 && "#DFE4E1",
        keyWord: component.title,
        value: "VALUE",
        col: component?.col || 6,
      })}
    </Card>
  )
}

const ShowSlideOrComponentType = ({ questionType, onChangeFixedComponent, initialComponents }) => {
  const properties = {
    prevArrow: (
      <button className="button-nav button-nav--left">
        <MdOutlineArrowBackIosNew size={24} />
      </button>
    ),
    nextArrow: (
      <button className="button-nav button-nav--right">
        <MdOutlineArrowForwardIos size={24} />
      </button>
    ),
  }

  return questionType !== "text" ? (
    <Slide indicators={true} {...properties}>
      {initialComponents.map((component, index) => {
        return (
          questionType !== "text" &&
          component?.type !== "table" && (
            <CardComponents {...{ index, component, onChangeFixedComponent }} />
          )
        )
      })}
    </Slide>
  ) : (
    <>
      {initialComponents.map((component, index) => {
        return (
          component?.type === "table" && (
            <CardComponents {...{ index, component, onChangeFixedComponent }} />
          )
        )
      })}
    </>
  )
}

export const AssistanceModal = ({
  saveOrUpdateClusteredFiles,
  clusteredPathTopics,
  setSelected,
  showInputClustered,
  handleChangeClusteredTitle,
  register,
  errors,
  uploadedImage,
  onChangeFile,
  loading,
  processingFile,
  onSaveReportListPath,
  modalIsOpen,
  setModalIsOpen,
  updateLabelInput,
  updateList,
  reload
}) => {
  return (
    <>
      {modalIsOpen.newClusteredIsOpen && (
        <ModalPanel modalIsOpen={modalIsOpen.newClusteredIsOpen} width={500}>
          <ModalHeader
            closeModal={() => setModalIsOpen({ newClusteredIsOpen: false })}
            title="Fixar Gráfico"></ModalHeader>
          <ModalBody>
            <CardModal className="modal-treeview">
              {/* <div className="treeview-item">
                <MultiSelectCheckbox data={clusteredPathTopics} setSelected={setSelected} />
              </div> */}

              {showInputClustered && (
                <>
                  <Label label={updateLabelInput} />
                  <Input onChange={handleChangeClusteredTitle} />
                </>
              )}
            </CardModal>
          </ModalBody>
          <ModalFooter>
            <Button
              className="button-engagement"
              loading={false}
              handleClick={reload}
              color="orange"
              variant="outline"
              label={"Recarregar"}
            />
            <ButtonLoader
              className="button-engagement"
              loading={false}
              handleClick={saveOrUpdateClusteredFiles}
              color="orange"
              label={"Salvar"}
            />
          </ModalFooter>
        </ModalPanel>
      )}
      {modalIsOpen.newListIsOpen && (
        <ModalPanel modalIsOpen={modalIsOpen.newListIsOpen}>
          <ModalHeader
            closeModal={() => setModalIsOpen({ newListIsOpen: false })}
            title={updateList ? "Editar Lista" : "Nova Lista"}></ModalHeader>
          <ModalBody>
            <CardModal>
              <FormRow>
                <Label label="Titulo" />
                <Input
                  placeholder={"Digite aqui o titulo"}
                  register={register("title", {
                    required: { value: true, message: "Campo Obrigatório" },
                  })}
                  hasError={errors.title?.message}
                  tabindex="1"
                />
              </FormRow>
              <FormRow>
                <Label label="Descrição" />
                <Input
                  placeholder={"Digite aqui a descrição"}
                  register={register("description", {
                    required: { value: true, message: "Campo Obrigatório" },
                  })}
                  hasError={errors.description?.message}
                  tabindex="2"
                />
              </FormRow>
              <div className="card-reports-cover">
                <LinkOrUpload
                  labelInput="Link da Imagem"
                  placeholderInput="Digite aqui o link da Imagem"
                  labelButton={uploadedImage ? "Editar Imagem" : "Upload Imagem"}
                  name="linkImage"
                  register={register}
                  handleFileChange={onChangeFile}
                  errors={errors.linkImage?.message}
                  acceptFile="image/png"
                  nameFile="picture"
                  required={{
                    validate: (value) =>
                      isValidURL(value) || "Url Inválida. Ex: https://www.manejebem.com",
                  }}
                />
              </div>
            </CardModal>
          </ModalBody>
          <ModalFooter>
            <ButtonLoader
              loading={loading || processingFile}
              messageProcess={processingFile ? "Aguarde, fazendo upload..." : "Salvando"}
              label={"Salvar"}
              color="orange"
              handleClick={onSaveReportListPath}
            />
          </ModalFooter>
        </ModalPanel>
      )}
    </>
  )
}

const AssistanceAnalysisScreen = ({
  initialComponents,
  questionType,
  handleOnSelect,
  setSelected,
  value,
  loadOptions,
  reportChartList,
  reportPathListSelectedId,
  saveOrUpdateClusteredFiles,
  clusteredPathTopics,
  onChangeFixedComponent,
  goToReports,
  showInputClustered,
  handleChangeClusteredTitle,
  register,
  errors,
  uploadedImage,
  onChangeFile,
  loading,
  processingFile,
  onSaveReportListPath,
  onSavePathTopics,
  modalIsOpen,
  setModalIsOpen,
  updateLabelInput,
  reload
}) => {
  return (
    <>
      <Card className="farmer-historic-container no-border">
        <HeaderContent>
          <CardTitle title="Análise de Atendimento" />
        </HeaderContent>
        <div className="select-input-container">
          <ListSuggestionsItem
            selectedValue={value}
            handleOnSelect={handleOnSelect}
            loadOptions={loadOptions}
          />
        </div>

        <div className="diagnosis-card-container">
          {initialComponents.length > 0 ? (
            <ShowSlideOrComponentType
              {...{ questionType, onChangeFixedComponent, initialComponents }}
            />
          ) : (
            <EmptyScreen label="Faça uma pergunta no campo de busca!" />
          )}
        </div>
      </Card>
      <Card className="cards-folder-containter no-border">
        <div className="folders-section">
          <HeaderContent>
            <CardTitle title="Listagem de Relatórios" className="flex-start" />
            <Button
              color="orange"
              label="Nova Lista"
              handleClick={() => setModalIsOpen({ newListIsOpen: true })}
            />
          </HeaderContent>
          <div className="diagnosis-container-folders">
            {reportChartList.length > 0 &&
              reportChartList.map((item) => (
                <Card className={`card-folder card-folder--${item.id === reportPathListSelectedId ? "active" : "inactive"}`} onClick={() => goToReports(item.id)}>
                  <div className="card-folder-content">
                    <div
                      className="card-image-folder"
                      style={{ backgroundImage: `url(${item?.image})` }}></div>
                    <div className="card-content-info">
                      <h4>{item?.title}</h4>
                      <div className="card-content-info-desc">
                        <p>{item.description}</p>
                        <span>
                          <strong>{item.path_topics.length || 0}</strong> Tópicos
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
          </div>
        </div>
      </Card>
      <AssistanceModal
        {...{
          saveOrUpdateClusteredFiles,
          clusteredPathTopics,
          showInputClustered,
          handleChangeClusteredTitle,
          register,
          errors,
          uploadedImage,
          onChangeFile,
          loading,
          processingFile,
          onSaveReportListPath,
          onSavePathTopics,
          modalIsOpen,
          setModalIsOpen,
          updateLabelInput,
          setSelected,
          reload
        }}
      />
    </>
  )
}

export default AssistanceAnalysisScreen
